import React from 'react';

const TabTitle = ({title}) => <h4 className="user-detail-headings">{title}</h4>


export default TabTitle;